/**
 * Protected Route
 */

import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from './routeConfig';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  // Check localStorage directly
  const storedUser = localStorage.getItem('user');
  
  if (!storedUser) {
    return <Navigate to={ROUTES.AUTH.LOGIN} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
